import { render, staticRenderFns } from "./appTextarea.vue?vue&type=template&id=a92a63be"
import script from "./appTextarea.vue?vue&type=script&lang=js"
export * from "./appTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports